import { useApi } from "./useApi";
import { Events, dispatch } from "../redux/dispatch";

export const useSpiderman = () => {
  const { client } = useApi();
  const notifyError = (message = "No fue posible completar la operación.") => {
    dispatch(Events.SHOW_ALERT, {
      message,
      type: "ERROR",
    });
  };

  const createOwnerCode = async () => {
    try {
      const codes = await client.post("/v1/spiderman/codes/owners");
      return codes;
    } catch (err) {
      notifyError("No fue posible crear el código para propietarios.");
      return null;
    }
  };

  const getOwnerCodes = async () => {
    try {
      const codes = await client.get("/v1/spiderman/codes/owners");
      return codes;
    } catch (err) {
      notifyError("No fue posible obtener los códigos para propietarios.");
      return null;
    }
  };

  const getOwners = async () => {
    try {
      return await client.get("/v1/spiderman/users/owners");
    } catch (err) {
      notifyError("No fue posible obtener la lista de propietarios.");
      return [];
    }
  };

  const createUserCode = async (poolId) => {
    try {
      return await client.post("/v1/spiderman/codes/owners/users", {
        poolId,
      });
    } catch (err) {
      notifyError("No fue posible crear el código de usuario.");
      return null;
    }
  };

  return { getOwnerCodes, createOwnerCode, getOwners, createUserCode };
};
